import request from "@/util/http";

/**
 * 秒杀查询
 * @param {Object} query
 */
export function list(query) {
	return request({
		url: '/marketing/shop/group_marketing/list',
		method: 'get',
		params: query,
	})
}

/**
 * 秒杀查询
 * @param {Object} query
 */
export function group_list(query) {
	return request({
		url: '/marketing/shop/group_marketing/list',
		method: 'get',
		params: query,
	})
}

// module.exports = {
// 	list,
// 	group_list,
// }
